export const environment = {
    production: false,
    development:false,
    staging:true,
    designerBackendApi: 'https://stage.designer.spooorts.de/',
    designerFrontendApi:"https://stage.designer.se2.tech/",
    designerIframe:'https://stage.designeriframe.se2.tech/',
    loginApi:'https://stage.login.spooorts.de/login/',
    localhostTestApi:"http://localhost:8080/",
    creatorAdminApi:'https://stage.creatoradmin.spooorts.de/',

    spooortsEventApi:'https://stage.event.spooorts.de/',
    spooortsBa2Api:'https://stage.ba2.spooorts.de/',
    spooortsSportApi:'https://stage.sportevent.spooorts.de/',
    spooortsAdminApi:'https://spooorts.de/admin/',
    spooortsTournamentApi:'https://stage.tournament.spooorts.de/',
    spooortsBackofficeApi:'https://stage.backoffice.spooorts.de/',
    spooortsApi:'https://spooorts.de/'
};